module.exports = __webpack_public_path__ + "img/p-22.7b60bcb4.jpg";